import React  from 'react';
import { Outlet } from 'react-router';
import { useGoogleTracking } from '../../hooks/useGoogleTracking';
import { useScrollToAnchor } from '../../hooks/useScrollBarToAnchor';
import TemplateFooter from '../TemplateFooter/TemplateFooter';
import TemplateHeader from '../TemplateHeader/TemplateHeader';
import styles from './TemplateLayout.module.css';

const TemplateLayout = () => {
  useGoogleTracking();
  useScrollToAnchor();
  return (<>
    <TemplateHeader />
  <div className={styles.TemplateLayout} data-testid="TemplateLayout">
    <Outlet />
    <TemplateFooter />
  </div>
  </>
)};

export default TemplateLayout;